import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProductAlt = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 116,
	height: 116,
	fill: "none",
	viewBox: "0 0 116 116",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 116,
			height: 116,
			fill: "#FAFAFA"
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .6,
			children: [
				/* @__PURE__ */ _jsx("rect", {
					width: 31.3687,
					height: 21.5049,
					x: 40.2821,
					y: 51.0952,
					stroke: "#BEBEBE",
					strokeWidth: 1.32986,
					rx: .664932,
					transform: "rotate(-13.1418 40.2821 51.0952)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 52.0459,
					cy: 55.7849,
					r: 2.48018,
					fill: "#D9D9D9",
					stroke: "#BEBEBE",
					strokeWidth: 1.32986,
					transform: "rotate(-13.1418 52.0459 55.7849)"
				}),
				/* @__PURE__ */ _jsxs("g", {
					clipPath: "url(#pet__clip0_7340_10561)",
					children: [/* @__PURE__ */ _jsx("path", {
						fill: "#D9D9D9",
						stroke: "#BEBEBE",
						strokeWidth: 1.32986,
						d: "M51.6509 61.658C50.9647 61.05 49.8835 61.3025 49.5375 62.1514L45.6258 71.7483C45.2184 72.7478 46.1086 73.7906 47.1597 73.5452L58.8282 70.8209C59.8793 70.5755 60.2156 69.2463 59.4077 68.5305L51.6509 61.658Z"
					}), /* @__PURE__ */ _jsx("path", {
						fill: "#D9D9D9",
						stroke: "#BEBEBE",
						strokeWidth: 1.32986,
						d: "M62.0109 52.0285C61.3129 51.319 60.1116 51.5995 59.7999 52.5447L54.1497 69.6818C53.8247 70.6677 54.7042 71.6293 55.7151 71.3933L74.0198 67.1195C75.0308 66.8835 75.3935 65.6319 74.6655 64.8919L62.0109 52.0285Z"
					})]
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 31.3687,
					height: 21.5049,
					x: 40.2821,
					y: 51.0952,
					stroke: "#BEBEBE",
					strokeWidth: 1.32986,
					rx: .664932,
					transform: "rotate(-13.1418 40.2821 51.0952)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 39.903,
					height: 30.0312,
					x: 35.1571,
					y: 47.9138,
					fill: "#F5F5F5",
					stroke: "#BEBEBE",
					strokeWidth: 1.32986,
					rx: 1.99479,
					transform: "rotate(-13.1418 35.1571 47.9138)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 39.903,
					height: 30.0312,
					x: 38.0487,
					y: 42.9845,
					fill: "#F5F5F5",
					stroke: "#BEBEBE",
					strokeWidth: 1.32986,
					rx: 1.99479
				}),
				/* @__PURE__ */ _jsxs("g", {
					clipPath: "url(#pet__clip1_7340_10561)",
					children: [
						/* @__PURE__ */ _jsx("path", {
							fill: "#D9D9D9",
							stroke: "#BEBEBE",
							strokeWidth: 1.32986,
							d: "M50.9856 60.1187C50.4556 59.3706 49.3454 59.3706 48.8154 60.1187L42.8242 68.5748C42.2003 69.4555 42.83 70.6735 43.9094 70.6735H55.8917C56.971 70.6735 57.6008 69.4555 56.9768 68.5748L50.9856 60.1187Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							fill: "#D9D9D9",
							stroke: "#BEBEBE",
							strokeWidth: 1.32986,
							d: "M63.2636 53.0969C62.7452 52.2473 61.5115 52.2473 60.9931 53.0969L51.5946 68.5006C51.0539 69.3868 51.6917 70.5231 52.7298 70.5231H71.5269C72.565 70.5231 73.2028 69.3868 72.6621 68.5006L63.2636 53.0969Z"
						}),
						/* @__PURE__ */ _jsx("circle", {
							cx: 52.7056,
							cy: 54.4893,
							r: 2.48018,
							fill: "#D9D9D9",
							stroke: "#BEBEBE",
							strokeWidth: 1.32986
						})
					]
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 31.3687,
					height: 21.5049,
					x: 42.3163,
					y: 47.2475,
					stroke: "#BEBEBE",
					strokeWidth: 1.32986,
					rx: .664932
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 31.3687,
					height: 21.5049,
					x: 42.3163,
					y: 47.2475,
					stroke: "#BEBEBE",
					strokeWidth: 1.32986,
					rx: .664932
				})
			]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("clipPath", {
			id: "pet__clip0_7340_10561",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 33.2466,
				height: 19.283,
				fill: "white",
				transform: "translate(39.8602 52.8879) rotate(-13.1418)"
			})
		}), /* @__PURE__ */ _jsx("clipPath", {
			id: "pet__clip1_7340_10561",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 33.2466,
				height: 19.283,
				fill: "white",
				transform: "translate(41.4976 48.8975)"
			})
		})] })
	]
});
const ForwardRef = forwardRef(SvgProductAlt);
export default ForwardRef;
